// extracted by mini-css-extract-plugin
module.exports = {"level":"AudioInputLevel_level__3A_-1"};